<template>
  <b-modal
    id="share-social-media-modal"
    ref="modal"
    centered
    class="full-screen-modal"
    ok-variant="primary">

    <template #modal-header="{ close }">
      <div class="modal-header-content step4 w-100">
        <div class="title-share-container h-100">
          <div class="d-flex align-items-center mb-2 d-md-none cursor-pointer" @click="handleSubmit">
            <svg class="header-button" fill="none" height="36" viewBox="0 0 30 30" width="36"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                d="M26.25 15C26.25 17.225 25.5902 19.4001 24.354 21.2502C23.1179 23.1002 21.3609 24.5422 19.3052 25.3936C17.2495 26.2451 14.9875 26.4679 12.8052 26.0338C10.623 25.5998 8.61839 24.5283 7.04505 22.955C5.47171 21.3816 4.40025 19.3771 3.96617 17.1948C3.53209 15.0125 3.75487 12.7505 4.60636 10.6948C5.45785 8.63914 6.89979 6.88213 8.74984 5.64597C10.5999 4.4098 12.775 3.75 15 3.75C17.9837 3.75 20.8452 4.93526 22.955 7.04505C25.0647 9.15483 26.25 12.0163 26.25 15Z"
                fill="#EAEAEA"
                opacity="0.2"/>
              <path
                d="M15 2.8125C12.5895 2.8125 10.2332 3.52728 8.22899 4.86646C6.22477 6.20564 4.66267 8.10907 3.74022 10.336C2.81778 12.563 2.57643 15.0135 3.04668 17.3777C3.51694 19.7418 4.67769 21.9134 6.38214 23.6179C8.08659 25.3223 10.2582 26.4831 12.6223 26.9533C14.9865 27.4236 17.437 27.1822 19.664 26.2598C21.8909 25.3373 23.7944 23.7752 25.1335 21.771C26.4727 19.7668 27.1875 17.4105 27.1875 15C27.1841 11.7687 25.899 8.67076 23.6141 6.3859C21.3292 4.10104 18.2313 2.81591 15 2.8125ZM15 25.3125C12.9604 25.3125 10.9666 24.7077 9.27069 23.5745C7.57481 22.4414 6.25303 20.8308 5.4725 18.9464C4.69197 17.0621 4.48775 14.9886 4.88566 12.9881C5.28357 10.9877 6.26574 9.15019 7.70797 7.70796C9.1502 6.26573 10.9877 5.28356 12.9881 4.88565C14.9886 4.48774 17.0621 4.69196 18.9464 5.47249C20.8308 6.25302 22.4414 7.5748 23.5745 9.27068C24.7077 10.9666 25.3125 12.9604 25.3125 15C25.3094 17.7341 24.2219 20.3553 22.2886 22.2886C20.3553 24.2219 17.7341 25.3094 15 25.3125ZM17.5383 10.9758L13.5129 15L17.5383 19.0242C17.6254 19.1113 17.6945 19.2147 17.7416 19.3285C17.7888 19.4423 17.813 19.5643 17.813 19.6875C17.813 19.8107 17.7888 19.9327 17.7416 20.0465C17.6945 20.1603 17.6254 20.2637 17.5383 20.3508C17.4512 20.4379 17.3478 20.507 17.234 20.5541C17.1202 20.6013 16.9982 20.6255 16.875 20.6255C16.7518 20.6255 16.6298 20.6013 16.516 20.5541C16.4022 20.507 16.2988 20.4379 16.2117 20.3508L11.5242 15.6633C11.4371 15.5762 11.3679 15.4728 11.3207 15.359C11.2736 15.2452 11.2493 15.1232 11.2493 15C11.2493 14.8768 11.2736 14.7548 11.3207 14.641C11.3679 14.5272 11.4371 14.4238 11.5242 14.3367L16.2117 9.64922C16.2988 9.56212 16.4022 9.49302 16.516 9.44588C16.6298 9.39874 16.7518 9.37448 16.875 9.37448C16.9982 9.37448 17.1202 9.39874 17.234 9.44588C17.3478 9.49302 17.4512 9.56212 17.5383 9.64922C17.6254 9.73632 17.6945 9.83973 17.7416 9.95353C17.7888 10.0673 17.813 10.1893 17.813 10.3125C17.813 10.4357 17.7888 10.5577 17.7416 10.6715C17.6945 10.7853 17.6254 10.8887 17.5383 10.9758Z"
                fill="#EAEAEA"/>
            </svg>
            <h1 class="page-title ml-3 ">{{ $t('share.Annonce') }}</h1>
          </div>
          <h1 class="page-title d-none d-md-block">{{ $t('share.Annonce') }}</h1>
        </div>
      </div>
    </template>

    <div>
      <div class="share-container ">
        <div class="col-md-6 w-100">
          <div id="copy-link" class="col-md-6 p-3 custom-share-item w-100 copy-clipboard cursor-pointer"
               @click="copyToClipboard">
            <i class="ph-custom ph-copy pr-3"></i>
            <span>{{ $t('copy.link.clipboard') }}</span>
          </div>
          <b-tooltip placement="bottom" target="copy-link" triggers="click">
            {{ $t('link.copied') }}
          </b-tooltip>
        </div>
        <div v-for="network in networks" class="col-md-6 w-100">
          <ShareNetwork :key="network.network"
                        :description="sharing.description"
                        :hashtags="sharing.hashtags"
                        :network="network.network"
                        :quote="sharing.quote"
                        :style="{backgroundColor: network.color}"
                        :title="sharing.title"
                        :twitterUser="sharing.twitterUser"
                        :url="sharing.url"
                        class="col-md-6 p-3 custom-share-item w-100"
          >
            <i :class="network.icon" class="pr-3"></i>
            <span>{{ network.name }}</span>
          </ShareNetwork>
        </div>
      </div>
    </div>


    <template #modal-footer="{ ok, cancel, hide }">
      <div class="w-100 d-flex">
        <b-button id="close-share-button" class="w-100 mr-2 d-none d-md-block" variant="secondary"
                  @click="handleSubmit()">
          <div class="d-flex justify-content-center">
            <span class="align-self-center mt-small-px">{{ $t('Close') }}</span>
          </div>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>
<script>
import api from '../../services/api'

export default {
  name: "ShareSocialMediaModal",

  props: {
    id: {
      type: Number,
      required: true,
      default: -1
    },
    vehicle: {
      type: Object,
      required: true,
      default: {
        brand: '',
        model: '',
        color: '',
        finish: ''
      }
    }
  },
  data() {
    return {
      redirectConnexionUrl: '',
      sharing: {
        url: `${this.redirectConnexionUrl}/openapp?id=${this.id}`,
        title: `${this.vehicle.brand} ${this.vehicle.model} ${this.$t(this.vehicle.color ? this.vehicle.color.value : '')} ${this.vehicle.modelFinish}`,
        description: 'Retrouvez ce véhicule et gagnez une récompense',
        quote: '',
        hashtags: 'LAMP',
        twitterUser: 'LAMP'
      },
      networks: [
        {network: 'email', name: 'Email', icon: 'ph-custom ph-envelope-simple', color: '#333333'},
        {network: 'facebook', name: 'Facebook', icon: 'ph-custom ph-facebook-logo', color: '#1877f2'},
        {network: 'messenger', name: 'Messenger', icon: 'ph-custom ph-messenger-logo', color: '#0084ff'},
        {network: 'sms', name: 'SMS', icon: 'ph-custom ph-chat-centered-dots', color: '#333333'},
        {network: 'telegram', name: 'Telegram', icon: 'ph-custom ph-telegram-logo', color: '#0088cc'},
        {network: 'twitter', name: 'Twitter', icon: 'ph-custom ph-twitter-logo', color: '#1da1f2'},
        {network: 'whatsapp', name: 'Whatsapp', icon: 'ph-custom ph-whatsapp-logo', color: '#25d366'},
      ]
    };
  },

  async mounted() {
    await this.fetchRedirectConnexionUrl()
  },

  methods: {

    async fetchRedirectConnexionUrl() {
      const response = await api.get('/home/getEnvironmentLinks')
      this.sharing.url = `${response.data.gpUrlLink}/openapp?id=${this.id}`
      this.redirectConnexionUrl = response.data.gpUrlLink
    },
    handleSubmit() {
      this.$bvModal.hide('share-social-media-modal')
    },

    copyToClipboard() {
      const url = `${this.redirectConnexionUrl}/openapp?id=${this.id}`;
      navigator.clipboard.writeText(url).then(() => {
      }, (err) => {
        console.error('Erreur lors de la copie: ', err);
      });
    },
  },
};
</script>

<!-- not scoped car modal -->
<style>

/** pour éviter les 17px de padding qui s'ajoutent en responsive */
#share-social-media-modal {
  padding-left: 0px !important;
}

#share-social-media-modal .modal-content,
#share-social-media-modal .modal-header,
#share-social-media-modal .modal-body,
#share-social-media-modal .modal-footer {
  background-color: var(--main-black-dark) !important;
}

#share-social-media-modal .modal-header-content {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start !important;
  padding: 0;
  border-bottom: none;
}

#share-social-media-modal .title-share-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  flex-direction: column;
}

@media (min-width: 992px) {
  #share-social-media-modal .title-share-container {
    flex-direction: column;
  }
}

@media (max-width: 991px) {
  #share-social-media-modal .title-share-container img {
    order: 2;
    align-self: center;
  }

  #share-social-media-modal .title-share-container {
    text-align: center;
  }
}

#share-social-media-modal .modal-content {
  overflow: hidden;
  border-radius: 30px;
}


#share-social-media-modal .full-screen-modal .modal-dialog {
  max-width: 100%;
  margin: 0;
}

#share-social-media-modal .full-screen-modal .modal-content {
  height: auto;
  border-radius: 30px;
}

@media (max-width: 767px) {
  #share-social-media-modal .modal-content {
    display: flex;
    border-radius: 0px;
    overflow: auto;
  }

  #share-social-media-modal .modal-dialog {
    max-width: 100%;
    margin: 0;
  }

  #share-social-media-modal .modal-body {
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }

  #share-social-media-modal .modal-dialog {
    max-width: 100%;
    margin: 0;
  }

  #share-social-media-modal .modal-content {
    padding: 0;
    border-radius: 0;
  }

  #share-social-media-modal .modal-header-content, .title-share-container {
    padding: 10px;
  }
}


#share-social-media-modal #close-share-button, #share-social-media-modal .btn-secondary {
  background-color: var(--main-black-dark) !important;
  border-color: var(--main-grey-light) !important;
  color: var(--main-white);
  border-radius: var(--main-border-radius);
  padding: 12px 20px;
  font-size: var(--content-font-size);
}

#share-social-media-modal #close-share-button:hover:not([disabled]), #share-social-media-modal .btn-secondary:hover:not([disabled]) {
  background-color: var(--main-black-medium) !important;
}

#share-social-media-modal .custom-share-item {
  border-radius: var(--main-border-radius);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  max-width: 100% !important;
  margin-bottom: 15px;
}

#share-social-media-modal .custom-share-item:hover {
  text-decoration: none !important;
  color: unset;
  opacity: 0.75;
}

#share-social-media-modal .share-container {
  display: flex;
  flex-wrap: wrap;
  margin-left: -15px;
  margin-right: -15px;
}

#share-social-media-modal .copy-clipboard {
  background-color: rgb(51, 51, 51);
}
</style>



// WEBPACK FOOTER //
// src/views/annonce/ShareSocialMediaModal.vue